module.exports = __webpack_public_path__ + "img/e1c2898172b4c841041d827e5d118bfe-lost_page_day.png";